import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './LegalPage.css';


const PrivacyPolicy = () => {
  return (
    <>
      <Header />
      <div className="legal-page">
        <div className="legal-container">
          <Link to="/" className="back-link">← Back to Home</Link>
          
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-date">Last Updated: January 27, 2026</p>
          
          <div className="legal-content">
            <p className="legal-intro">
              VIDYADHAR GLOBAL AI INNOVATIONS PRIVATE LIMITED ("Company", "we", "our", "us"), operating as WhiteLabelDevs, respects your privacy and is committed to protecting the personal information you share with us.
            </p>
            
            <section className="legal-section">
              <h2>1. Information We Collect</h2>
              <p>We may collect:</p>
              <ul>
                <li>Name, email, phone number, business details</li>
                <li>Project requirements and communication data</li>
                <li>Billing and transaction information</li>
                <li>Technical data such as IP address, browser type, pages visited</li>
                <li>Server and hosting account information (for cloud services)</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>2. How We Use Your Information</h2>
              <p>We use your information to:</p>
              <ul>
                <li>Provide Laravel development and white-label services</li>
                <li>Deliver cloud hosting and managed server services</li>
                <li>Communicate about projects, updates, and support</li>
                <li>Process payments and invoices</li>
                <li>Monitor server performance and security</li>
                <li>Improve our services and website</li>
                <li>Meet legal and compliance requirements</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>3. Cookies & Tracking</h2>
              <p>We may use cookies and analytics tools to improve user experience and website performance.</p>
            </section>
            
            <section className="legal-section">
              <h2>4. Data Sharing</h2>
              <p>We do not sell personal data. Information may be shared only with:</p>
              <ul>
                <li>Payment processors</li>
                <li>Hosting and technical partners (A2z Cloud and infrastructure providers)</li>
                <li>Legal authorities if required by law</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>5. Data Security</h2>
              <p>We implement reasonable technical and organizational measures to protect your data. However, no online transmission is 100% secure.</p>
            </section>
            
            <section className="legal-section">
              <h2>6. Your Rights</h2>
              <p>You may request to:</p>
              <ul>
                <li>Access, correct, or delete your data</li>
                <li>Withdraw consent</li>
                <li>Stop marketing communication</li>
              </ul>
              <p>Email: <a href="mailto:support@whitelabeldevs.com">support@whitelabeldevs.com</a></p>
            </section>
            
            <section className="legal-section">
              <h2>7. Third-Party Links</h2>
              <p>Our website may contain links to third-party sites. We are not responsible for their privacy practices.</p>
            </section>
            
            <section className="legal-section">
              <h2>8. Changes to Policy</h2>
              <p>We may update this policy at any time. Continued use of the website means acceptance of changes.</p>
            </section>
          </div>
          
          <div className="legal-footer">
            <p><strong>VIDYADHAR GLOBAL AI INNOVATIONS PRIVATE LIMITED</strong></p>
            <p>Operating as: WhiteLabelDevs</p>
            <p>CIN: U62090UP2026PTC241378</p>
            <p>2 Maa Pitambara Complex, Dwarika Green Phase 2, Agra Bamroli Road, UP 282009</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;